.error {
  width: 100%;
  min-height: 19px;
  // position: absolute;
  // top: 59px;
  // left: 0;
  margin-top: 1px;
  margin-left: 10px;
  font-size: 11px;
  line-height: 14px;
  color: #f76060;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-bottom: 3px;

  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis; 

  img {
    width: 12px;
    margin-right: 2px;
    position: relative;
    bottom: -1px;
  }

  // p {
  //   width: 100%;
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis; 
  // }
}

// Dark mode
:global body.dark {
  :local {
    .error {
      color: #E44A08;
      p {
        color: #E44A08;
      }
    }
  }
}
